(() => {
  const normalize = (value) => value.toLowerCase().replace(/[^\p{L}\p{N}]+/gu, ' ').trim().split(/\s+/).filter(Boolean);

  const withinOneEdit = (left, right) => {
    if (left === right) return true;
    if (Math.abs(left.length - right.length) > 1) return false;

    let leftIndex = 0;
    let rightIndex = 0;
    let edits = 0;
    while (leftIndex < left.length && rightIndex < right.length) {
      if (left[leftIndex] === right[rightIndex]) {
        leftIndex += 1;
        rightIndex += 1;
        continue;
      }
      edits += 1;
      if (edits > 1) return false;
      if (left.length > right.length) leftIndex += 1;
      else if (right.length > left.length) rightIndex += 1;
      else {
        leftIndex += 1;
        rightIndex += 1;
      }
    }
    if (leftIndex < left.length || rightIndex < right.length) edits += 1;
    return edits <= 1;
  };

  window.pushpauraSearchTitleMatches = (query, title) => {
    const queryWords = normalize(query);
    const titleWords = normalize(title);
    if (queryWords.length === 0 || titleWords.length === 0) return false;

    return queryWords.every((queryWord) =>
      titleWords.some((titleWord) =>
        queryWord.length < 4 ? queryWord === titleWord : withinOneEdit(queryWord, titleWord),
      ),
    );
  };
})();
